import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectIsEmptyStateWithTags } from 'shared/selectors';
import { useApplicationContext } from 'shared/utils/applicationContext';

/**
 * Синхронизирует видимость тегов в микрофронте фильтров с состоянием выдачи.
 *
 * Изменение фильтров на клиенте перезапрашивает выдачу, и она может стать как пустой
 * с тегами (тогда теги рисует хост в блоке пустой выдачи, а микрофронт свои прячет),
 * так и обычной (тогда теги снова показывает микрофронт).
 */
export const useToggleFiltersTags = () => {
  const { logger, microfrontendsAPI, microfrontendsRegistry } = useApplicationContext();

  const isEmptyStateWithTags = useSelector(selectIsEmptyStateWithTags);

  useEffect(() => {
    if (!microfrontendsAPI || !microfrontendsRegistry.microfrontend('desktop-filters-micro-frontend')) {
      return;
    }

    const filtersApi = microfrontendsAPI.getDesktopFiltersMicrofrontendApi();
    const syncTagsVisibility = isEmptyStateWithTags ? filtersApi.hideTags : filtersApi.showTags;

    syncTagsVisibility().catch(error => {
      logger.error(error, { degradation: 'Синхронизация видимости тегов в микрофронте фильтров' });
    });
  }, [isEmptyStateWithTags, logger, microfrontendsAPI, microfrontendsRegistry]);
};
